import { Privacy } from '../components/privacy/types';
import { ActionData, Attachment } from '../lib/entities';
import { RichMediaState } from '../lib/state/rich-media-state';

export const actionData = ({
	attachment,
	calculateReceiversFn,
	calculateTotalFn,
	flashPointsBalance,
	includeGiver,
	privacy,
	state,
}: {
	attachment: Attachment | null;
	calculateReceiversFn?: (includeGiver: boolean) => number;
	calculateTotalFn?: (data: RichMediaState, state: { includeGiver: boolean }) => number;
	flashPointsBalance: number;
	includeGiver: boolean;
	privacy: Privacy;
	state: RichMediaState;
}) => {
	return new ActionData({
		attachment: attachment,
		amount: state.amount ?? null,
		flashPointsUsed: flashPointsBalance > 0 && state.totalAmount > 0,
		hashtags: state.hashtags,
		hasAmount: state.hasAmount,
		hasHashtag: state.hasHashtag,
		hasRecipient: state.hasRecipient,
		includeGiver: includeGiver,
		mentions: state.mentions,
		recipients: state.recipients,
		privacy: privacy,
		text: state.text,
		totalAmount: calculateTotalFn?.(state, { includeGiver }) || state.totalAmount,
		recipientCount: calculateReceiversFn?.(includeGiver) || state.recipientCount,
	});
};
